import { render, staticRenderFns } from "./InspirationSearchCard.vue?vue&type=template&id=1b702628"
import script from "./InspirationSearchCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InspirationSearchCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports